// import { reloadPage } from '../page/reload-page';
import * as React from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { PlaceHolderModuleName } from './module-load/utils.js';
import { getRawLayoutComponent } from './registry-layout-load.js';
import { BasePath, normaliseDynamicComponentName } from './registry-naming.js';

export type IModuleRegistryProps = IModule<IModuleConfig>;
export type IModuleRegistryItem = React.ComponentType<IModuleRegistryProps>;
export type ILayoutRegistryProps = any;
export type ILayoutRegistryItem = React.ComponentType<ILayoutRegistryProps>;
export type ICachedItems = IModuleRegistryProps | ILayoutRegistryProps;

type DynamicComponentProps = {
  debug: boolean;
};

const defaultDynamicComponentProps: DynamicComponentProps = {
  debug: false,
};

enum PreLoadedWarnings {
  WARNINGS_PANEL = 'warnings-panel/1',
}
/** We merge here so we can easily idenityf where placeholder gets used from its implementation file */
export const PreLoadedModules = { ...PreLoadedWarnings, ...PlaceHolderModuleName };
export type PreLoadedModules = typeof PreLoadedModules;
/**
 * factory function to manage dynamic components used for loading layout and module components
 * includes options for debugging
 **/
const dynamicComponentsInit = (_options: Partial<DynamicComponentProps> = {}) => {
  const options = Object.assign(defaultDynamicComponentProps, _options);
  const layoutMap = new Map<string, ILayoutRegistryItem | null>();
  // layoutMap.set(normaliseDynamicComponentName('map/1'), MapLayout);
  // const modulesMap = new Map<string, IModuleRegistryItem | null>();

  const layoutGetCached = (layoutName: string) => {
    const name = normaliseDynamicComponentName(layoutName, 'layoutGetCached Fn');
    if (name) {
      const layoutLoadedCache = layoutMap.get(name);
      if (options.debug) {
        messageLog.info(`Layout Request Cache`, ['name', name], ['inCache', !!layoutLoadedCache]);
      }
      return layoutLoadedCache;
    }
    return undefined;
  };

  const layoutGet = async (layoutName: string): Promise<ILayoutRegistryItem | null> => {
    const name = normaliseDynamicComponentName(layoutName, 'layoutGet Fn');

    if (name) {
      const cachedValue = layoutGetCached(name);
      if (cachedValue) {
        return cachedValue;
      }
      const layoutLoaded = await getRawLayoutComponent(name);

      layoutMap.set(name, layoutLoaded);
      // Display if layout is unable to load to aid debugging
      if (options.debug || !layoutLoaded) {
        messageLog.info(
          `Layout Request Load`,
          ['layoutName', layoutName],
          ['name', name],
          ['BasePath', BasePath],
          ['loadedandSavedInCache', !!layoutLoaded],
        );
      }
      return layoutLoaded;
    }
    return null;
  };
  return { layoutGetCached, layoutGet };
};

export const cachedComponents = dynamicComponentsInit({
  debug: __BUILD_ENV__ !== 'met',
});
